import Dexie from 'dexie';


const db = new Dexie('ckb_idb');
db.version(14).stores({
    solutions:'&id,title,settings',
    custom_fields:'&id,name,main_field,updated_at',
    custom_values:'&id,main,custom_field_id',
    // done_items:',++idb_id,ckb_id,done_form_id,execution_idb_idtitle,answer,sentence',
    // executions:'++idb_id,ckb_id,name,main,solution_id,user_id',
});

export default db;